<template>
  <div
    class="OddsPreview--Wrap"
    :class="[{ 'is-light': mode === 'light' }, { 'is-dark': mode === 'dark' }]"
  >
    <span class="OddsPreview--Link" v-html="content" ref="oddsLink" @click="oddsLinkClick" />
    <div class="OddsPreview" ref="OddsPreview" v-click-outside="hidePreview">
      <div class="OddsPreview--Content" v-if="oddsData" v-html="oddsData"></div>
    </div>
  </div>
</template>
<script>
import coreLibrary from "../../../core/helpers/CoreLibrary";
import anime from 'animejs';
import ClickOutside from 'vue-click-outside';
import * as actions from "../../Config/ApiUrl";
const OFFSET = 20;
const isMobile = window.innerWidth < 500;
export default {
  extends: coreLibrary,
  props: {
    content: {
      default: '-',
    },
    data: {
      default: null,
    },
    market: {
      default: null,
    },
    submarket: {
      default: null,
    },
    gameid: {
      default: null,
    },
    mode: {
      type: String,
      default: 'dark',
      validator: function (value) {
        // The value must match one of these strings
        return ['light', 'dark'].indexOf(value) !== -1;
      },
    },
  },
  data() {
    return {
      oddsData: null,
      lastClicked: 0,
    }
  },
  directives: {
    ClickOutside,
  },
  methods: {
    oddsLinkClick(){
      var comboSwitch = $('#combo_switch');
      var comboActive = false;

      if (comboSwitch){
        comboActive = comboSwitch.val();
      }

      if (comboActive == "true"){
        this.oddsClick();
      } else {
        this.lastClicked = Math.round(new Date().getTime() / 1000);
        this.showPreview();
      }
    },
    showPreview(){
      const elementRect = this.$refs.oddsLink.getBoundingClientRect();

      const spaceAbove = elementRect.top;
      const spaceBelow = window.innerHeight - elementRect.bottom;

      const element = this.$refs.OddsPreview;
      if (element.classList.contains('is-visible')) return;
      $('.OddsPreview.is-visible').each(function(){
        this.classList.remove('is-visible');
        this.parentNode.classList.remove('is-child-visible');
        anime({
          targets: this,
          translateY: [0, '20%'],
          translateX: 0,
          opacity: [1, 0],
          easing: 'spring(1, 80, 10, 4)',
        });
      });
      element.classList.add('is-visible');
      element.parentNode.classList.add('is-child-visible');
      const { y, x, width: linkWidth, height: linkHeight } = this.$refs.oddsLink.getBoundingClientRect();
      const { width: elementWidth } = element.getBoundingClientRect();
      if (spaceBelow < spaceAbove) {
        //console.log('above');
        anime({
          targets: element,
          left: isMobile
            ? ['50%', '50%']
            : [x - (elementWidth - linkWidth) / 2, x - (elementWidth - linkWidth) / 2],
          bottom: window.innerHeight - y + OFFSET,
          //translateY: ['50%', 0],
          translateX: isMobile ? ['-50%', '-50%'] : 0,
          opacity: [0, 1],
          easing: 'spring(1, 80, 12, 4)',
        });
      } else {
        ///console.log('below');
        anime({
          targets: element,
          left: isMobile
            ? ['50%', '50%']
            : [x - (elementWidth - linkWidth) / 2, x - (elementWidth - linkWidth) / 2],
          top: y + linkHeight + OFFSET,
          //translateY: ['50%', 0],
          translateX: isMobile ? ['-50%', '-50%'] : 0,
          opacity: [0, 1],
          easing: 'spring(1, 80, 12, 4)',
        });
      }

      this.axiosPost({
        url: actions.LOAD_ODDS_HISTORY,
        data: { 
          'gameid': this.gameid,
          'market': this.market, 
          'submarket': this.submarket, 
        },
      }).then(response => {
        if (response.data.status == 1){
          let data = response.data.changes;
          let length = data.length;
          let start = 0;
          let html = '<table style="width: 100%">';
          let changeClass = data[0].change > 0 ? 'up' : data[0].change < 0 ? 'down' : '';
          let change = data[0].change > 0 ? '+' + data[0].change : data[0].change;
          let maxChangeClass = data[0].max_change > 0 ? 'up' : data[0].max_change < 0 ? 'down' : '';
          let maxChange = data[0].max_change > 0 ? '+' + data[0].max_change : data[0].max_change;
          if (typeof data[0].max == 'undefined'){
            html += '<tr class="first-row"><td class="odds">' + data[0].value + '</td><td class="' + changeClass + '">' + change + '</td><td>' + data[0].time + '</td><td>' + data[0].date + '</td></tr>';
          } else {
            html += '<tr class="first-row"><td class="odds">' + data[0].value + '</td><td class="' + changeClass + '">' + change + '</td><td class="' + maxChangeClass + '">' + data[0].max + '</td><td>' + data[0].time + '</td><td>' + data[0].date + '</td></tr>';

          }
          if (length > 10){
            start = length - 10;
            if ((start - 1) > 0){
              if (typeof data[0].max == 'undefined'){
                html += '<tr><td colspan="4" class="text-center">+' + (start - 1) + ' changes</td></tr>';
              } else {
                html += '<tr><td colspan="5" class="text-center">+' + (start - 1) + ' changes</td></tr>';
              }
            }
          }
          if (start == 0) {
            start = 1;
          }
          for (let x = start; x < length; x++){
            changeClass = data[x].change > 0 ? 'up' : data[x].change < 0 ? 'down' : '';
            change = data[x].change > 0 ? '+' + data[x].change : data[x].change;
            maxChangeClass = data[x].max_change > 0 ? 'up' : data[x].max_change < 0 ? 'down' : '';
            maxChange = data[x].max_change > 0 ? '+' + data[x].max_change : data[x].max_change;
            if (typeof data[0].max == 'undefined'){
              html += '<tr><td class="odds">' + data[x].value + '</td><td class="' + changeClass + '">' + change + '</td><td>' + data[x].time + '</td><td>' + data[x].date + '</td></tr>';
            } else {
              html += '<tr><td class="odds">' + data[x].value + '</td><td class="' + changeClass + '">' + change + '</td><td class="' + maxChangeClass + '">' + data[x].max + '</td><td>' + data[x].time + '</td><td>' + data[x].date + '</td></tr>';
            }
          }
          if (typeof data[0].max == 'undefined'){
              html += '<tr class="history-link"><td colspan="4" class="text-center"><a href="/game/' + this.gameid + '?market=' + this.market + '&sub_market=' + this.submarket + '">' + this.$t('view_market_history') + '</a></td></tr>';
            } else {
              html += '<tr class="history-link"><td colspan="5" class="text-center"><a href="/game/' + this.gameid + '?market=' + this.market + '&sub_market=' + this.submarket + '">' + this.$t('view_market_history') + '</a></td></tr>';
            }
          html += '</table>';
          this.oddsData = html;
        } else if (response.data.status == 2){
        } else if (response.data.status == 0){
        }
      });
    },
    hidePreview() {
      let current = Math.round(new Date().getTime() / 1000);
      if ((current - this.lastClicked) < 2){
        return false;
      }
      const element = this.$refs.OddsPreview;
      if (!element.classList.contains('is-visible')) return;
      element.classList.remove('is-visible');
      element.parentNode.classList.remove('is-child-visible');
      const { y, x, width: linkWidth } = this.$refs.oddsLink.getBoundingClientRect();
      const { width: elementWidth } = element.getBoundingClientRect();
      anime({
        targets: this.$refs.OddsPreview,
        left: isMobile
          ? ['50%', '50%']
          : [x - (elementWidth - linkWidth) / 2, x - (elementWidth - linkWidth) / 2],
        bottom: window.innerHeight - y + OFFSET,
        translateY: [0, '20%'],
        translateX: isMobile ? ['-50%', '-50%'] : 0,
        opacity: [1, 0],
        easing: 'spring(1, 80, 10, 4)',
      });
    },
    oddsClick(){
      var row = this.data;
      var market = this.market;
      var submarket = this.submarket;

      var odds = JSON.parse(row['odds'])
      var game_id = row['id'];
      var game_name = row['name'];

      var selected_odds = odds[market][submarket];
      var selected_line = 0;

      if (market == 'asian' || market == 'totals'){
        selected_line = odds[market]['line'];
      }

      var formData = new FormData();
      formData.append('game_id', game_id);
      formData.append('market', market);
      formData.append('submarket', submarket);
      formData.append('line', selected_line);
      formData.append('odds', selected_odds);

      this.axiosPost({
        url: actions.COMBOS_ADD,
        data: formData,
      }).then(response => {
        if (response.data.status == 1){
          this.$toastr.s(this.$t('game_added_to_combo') + "<br/><b>" + game_name + "</b>");
        } else if (response.data.status == 2){
          this.$toastr.i(this.$t('game_market_updated_combo') + "<br/><b>" + game_name + "</b>");
        } else if (response.data.status == 0){
          this.$toastr.i(this.$t(response.data.message) + "<br/><b>" + game_name + "</b>");
        }
      });
    }
  },
};
</script>
<style lang="scss">
.OddsPreview--Wrap {
  position: relative;
  display: inline;
  text-align: left;
  &.is-child-visible {
    background: #c6c6c6;
  }
  .OddsPreview {
    width: clamp(250px, 30vw, 410px);
    opacity: 0;
    z-index: 1;
    position: fixed;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 0 60px 0 rgba(black, 0.15);
    will-change: auto;
    left: 0;
    //bottom: 0;
    opacity: 0;
    padding: 10px;
    pointer-events: none;
    color: black;
    > * {
      will-change: auto;
    }
    .first-row {
      background-color: #dddddd;
    }
    &.is-visible {
      pointer-events: all;
    }
    .OddsPreview--Person {
      display: flex;
      align-items: center;
    }
    .OddsPreview--Content {
      font-size: 0.85rem;
      margin-top: 20px;

      .odds {
        padding-left: 5px !important;
      }
    }
    .OddsPreview--Link {
      text-decoration: underline;
    }
    .up {
      color: #81bf5c;
    }
    .down {
      color: #bf5c5c;
    }
  }
}
[theme="dark"]{
  .OddsPreview {
    background-color: #353a47;
    .odds {
      color: white;
    }
    .first-row {
      background-color: #292c33;
      td {
        padding-top: 5px !important;
        padding-bottom: 5px !important;
      }
    }
    .history-link {
      td {
        padding-top: 5px !important;
      }
      a {
        color: #72798f !important;
        font-size: 0.9em;
      }
      a:hover {
        color: #878fa8 !important;
      }
    }
  }
  .OddsPreview--Wrap.is-child-visible {
    background: #464e60 !important;
    color: #fff;
  }
}
</style>